import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";

const InvoiceTable = () => {
  const [folders, setFolders] = React.useState([]);
  const [files, setFiles] = React.useState([]);
  const [selectedFolder, setSelectedFolder] = React.useState(null);
  const [loadingFolders, setLoadingFolders] = React.useState(false);
  const [loadingFiles, setLoadingFiles] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);

  React.useEffect(() => {
    setLoadingFolders(true);
    fetch("/api/invoice")
      .then((res) => res.json())
      .then((data) => {
        setFolders(data.folders || []);
      })
      .finally(() => setLoadingFolders(false));
  }, []);

  const handleFolderClick = (folderName) => {
    setSelectedFolder(folderName);
    setLoadingFiles(true);
    // Fetch files in that folder
    fetch(`/api/invoice/${encodeURIComponent(folderName)}`)
      .then((res) => res.json())
      .then((data) => {
        setFiles(data.files || []);
      })
      .finally(() => setLoadingFiles(false));
  };

  const handleDownload = (fileName) => {
    if (!selectedFolder) return;
    const url = `/api/invoice/download/${encodeURIComponent(selectedFolder)}/${encodeURIComponent(fileName)}`;
    axios({
      url,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch((error) => console.error("Error downloading file:", error));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", padding: 2 }}>
      <h2>Folders</h2>
      {loadingFolders ? (
        <Box sx={{ display: "flex", justifyContent: "center", padding: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        folders.map((folder) => (
          <Button
            key={folder}
            variant={folder === selectedFolder ? "contained" : "outlined"}
            sx={{ margin: 0.5 }}
            onClick={() => handleFolderClick(folder)}
          >
            {folder}
          </Button>
        ))
      )}

      {selectedFolder && (
        <>
          <h2>Files in: {selectedFolder}</h2>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="files table">
              <TableHead>
                <TableRow>
                  <TableCell>File Name</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              {loadingFiles ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Box sx={{ display: "flex", justifyContent: "center", padding: 2 }}>
                        <CircularProgress />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : files.length > 0 ? (
                <TableBody>
                  {files
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((file) => (
                      <TableRow key={file}>
                        <TableCell>{file}</TableCell>
                        <TableCell>
                          <Button
                            variant="outlined"
                            size="small"
                            endIcon={<DownloadIcon />}
                            onClick={() => handleDownload(file)}
                          >
                            Download
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={2}>No files in this folder</TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[50, 100, 200]}
            component="div"
            count={files.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}
    </Paper>
  );
};

export default InvoiceTable;

